import { ProfileDTO2Role } from '../../api/api';
import Select, { MenuItem } from '../select/Select';
import { getEnumDisplayValue, mapEnum } from '../../utils/enumUtils';

interface Props {
  role?: ProfileDTO2Role;
  onChange: (role: string) => void;
  label?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  error?: boolean;
}

const RolesDropdown = (props: Props) => {
  const { onChange, role } = props;

  const handleSelectRole = (role: ProfileDTO2Role) => {
    onChange(role);
  };

  return (
    <Select label="Rolle" fullWidth value={role || ''} onChange={(e) => handleSelectRole(e.target.value as ProfileDTO2Role)}>
      {mapEnum(ProfileDTO2Role).map((r, i) => {
        return (
          <MenuItem key={i} value={ProfileDTO2Role[r]}>
            {getEnumDisplayValue(ProfileDTO2Role[r])}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default RolesDropdown;
